export const PREDEFINED_BOM = {
  "solar_panels": [
    {
      "product_name": "SOLAR PANELS",
      "specifications": ["MONO-FACIAL", "BIFACIAL", "TOPCON", "HJT"],
      "category": "DCR",
      "capacity": "540-620",
      "make": ["ADANI", "WAAREE"],
      "unit": "NOS",
      "quantity": 5,
      "manufacturer_warranty": "12 YEARS MANUFACTURING & 30 YEARS PERFORMANCE"
    },
    {
      "product_name": "SOLAR PANELS",
      "specifications": ["MONO-FACIAL", "BIFACIAL", "TOPCON", "HJT"],
      "category": "NON DCR",
      "capacity": "540-620",
      "make": ["ADANI", "WAAREE"],
      "unit": "NOS",
      "quantity": 3,
      "manufacturer_warranty": "12 YEARS MANUFACTURING & 30 YEARS PERFORMANCE"
    }
  ],

  "solar_inverter": [
    {
      "product_name": "SOLAR INVERTER",
      "specifications": ["STRING", "MICRO", "HYBRID", "OFF-GRID"],
      "category": "SINGLE PHASE",
      "capacity": "5 KW",
      "make": ["INVOLTICS"],
      "unit": "NOS",
      "quantity": 1,
      "manufacturer_warranty": "10 YEARS"
    },
    {
      "product_name": "SOLAR INVERTER",
      "specifications": ["STRING", "MICRO", "HYBRID", "OFF-GRID"],
      "category": "THREE PHASE",
      "capacity": "10 KW",
      "make": ["INVOLTICS"],
      "unit": "NOS",
      "quantity": 1,
      "manufacturer_warranty": "10 YEARS"
    }
  ],

  "solar_batteries": [
    {
      "product_name": "SOLAR BATTERIES",
      "specifications": ["LEAD ACID", "SMF", "LITHIUM"],
      "category": null,
      "capacity": ["100 AH", "150 AH"],
      "make": ["EXIDE", "AMARON"],
      "unit": "NOS",
      "quantity": 4,
      "manufacturer_warranty": "3 YEARS"
    }
  ],

  "module_mounting_structure": {
    "section_name": "MODULE MOUNTING STRUCTURE",
    "sections": [
      {
        "roof_type": "RCC",
        "structure_height_front": null,
        "structure_height_back": null,
        "parts": [
          {
            "item_name": "LEGS",
            "specification": "PRE GI",
            "size": "75 MM X 75 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "RAFTER",
            "specification": "PRE GI",
            "size": "60 MM X 40 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "PURLIN",
            "specification": "PRE GI",
            "size": "40 MM X 40 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "BRACING",
            "specification": "PRE GI",
            "size": "40 MM X 40 MM X 2 MM",
            "shape": "C-CHANNEL",
            "make": ["REPUTED"]
          },
          {
            "item_name": "FOUNDATION",
            "specification": "300 MM X 300 MM X 300 MM",
            "size": null,
            "shape": "CUBE",
            "make": []
          },
          {
            "item_name": "OTHERS",
            "input_type": "TEXT_BOX"
          }
        ]
      },
      {
        "roof_type": "GROUND",
        "structure_height_front": null,
        "structure_height_back": null,
        "parts": [
          {
            "item_name": "LEGS",
            "specification": "PRE GI",
            "size": "75 MM X 75 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "RAFTER",
            "specification": "PRE GI",
            "size": "60 MM X 40 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "PURLIN",
            "specification": "PRE GI",
            "size": "40 MM X 40 MM X 2 MM",
            "shape": "SQUARE PIPE",
            "make": ["APPOLO", "TATA"]
          },
          {
            "item_name": "BRACING",
            "specification": "PRE GI",
            "size": "40 MM X 40 MM X 2 MM",
            "shape": "C-CHANNEL",
            "make": ["REPUTED"]
          },
          {
            "item_name": "FOUNDATION",
            "specification": "300 MM X 300 MM X 300 MM",
            "size": null,
            "shape": "CUBE",
            "make": []
          },
          {
            "item_name": "OTHERS",
            "input_type": "TEXT_BOX"
          }
        ]
      },
      {
        "roof_type": "TIN SHED",
        "structure_type": [
          "ALUMINIUM MONO RAIL",
          "GI CHANNEL",
          "RAISED",
          "OTHERS"
        ],
        "mounting_type": [
          "SDS",
          "RIVIT",
          "ADHASIVE CHEMICAL",
          "OTHERS"
        ]
      },
      {
        "roof_type": "COMBO",
        "parts": [
          {
            "s_no": 1,
            "item_name": "RCC",
            "no_of_panels": null
          },
          {
            "s_no": 2,
            "item_name": "GROUND",
            "no_of_panels": null
          },
          {
            "s_no": 3,
            "item_name": "TIN SHED",
            "no_of_panels": null
          }
        ],
        "note": "ABOVE STRUCTURE SPECS AS PER COMBO"
      },
      {
        "section_name": "SPECIAL STRUCTURE",
        "parts": [
          {
            "item_name": "STAIRS",
            "special_structure_type": null,
            "special_structure_specs": null,
            "special_structure_length": null
          },
          {
            "item_name": "RAILING",
            "special_structure_type": null,
            "specification": null,
            "special_structure_length": null
          },
          {
            "item_name": "WALKWAY",
            "special_structure_type": null,
            "specification": null,
            "special_structure_length": null
          },
          {
            "item_name": "LIFE SUPPORT",
            "special_structure_type": null,
            "specification": null,
            "special_structure_length": null
          },
          {
            "item_name": "CLEANING SYSTEM",
            "input_type": "TEXT_BOX"
          },
          {
            "item_name": "OTHERS",
            "input_type": "TEXT_BOX"
          }
        ]
      }
    ]
  },

  "protection_devices": [
    {
      "product_name": "DCDB",
      "specification": "COMPANY STANDARD",
      "category": null,
      "details": "FUSE WITH SPD",
      "make": "REPUTED",
      "unit": "NOS",
      "quantity": null,
      "manufacturer_warranty": null
    },
    {
      "product_name": "ACDB",
      "specification": "COMPANY STANDARD",
      "category": ["SINGLE PHASE", "THREE PHASE"],
      "details": "MCB WITH SPD",
      "make": "REPUTED",
      "unit": "NOS",
      "quantity": null,
      "manufacturer_warranty": null
    },
    {
      "product_name": "ISOLATOR (BRAKER)",
      "specification": "COMPANY STANDARD",
      "category": ["SINGLE PHASE", "THREE PHASE"],
      "details": "MCB/MCCB",
      "make": "REPUTED",
      "unit": "NOS",
      "quantity": null,
      "manufacturer_warranty": null
    }
  ],

  "earthing_kit": [
    {
      "product_name": "EARTHING RODS",
      "specification": "COMPANY STANDARD",
      "category": "COPPER BONDED",
      "size": "1 METER",
      "make": "REPUTED",
      "unit": "NOS",
      "quantity": null
    },
    {
      "product_name": "LIGHTNING ARRESTER",
      "specification": "COMPANY STANDARD",
      "category": "COPPER BONDED",
      "size": "1 METER",
      "make": "REPUTED",
      "unit": "NOS",
      "quantity": null
    }
  ],

  "cables": [
    {
      "product_name": "DC CABLE",
      "specification": "COMPANY STANDARD",
      "category": "4 SQMM 1C",
      "size": "COPPER",
      "make": "REPUTED"
    },
    {
      "product_name": "EARTHING CABLE",
      "specification": "COMPANY STANDARD",
      "category": "6 SQMM 1C",
      "size": "CCA",
      "make": "REPUTED"
    },
    {
      "product_name": "AC CABLE",
      "specification": "COMPANY STANDARD",
      "category": "10 SQMM 4 C",
      "size": "ALUMINIUM ARMORED",
      "make": "REPUTED"
    },
    {
      "product_name": "EARTHING STRIP",
      "specification": "COMPANY STANDARD",
      "category": "25X3",
      "size": "GI",
      "make": "REPUTED"
    },
    {
      "product_name": "LA CABLE",
      "specification": "COMPANY STANDARD",
      "category": "6 SQMM 1C",
      "size": "CCA",
      "make": "REPUTED"
    }
  ],

  "electric_meters": [
    {
      "product_name": "SOLAR METER",
      "specification": null,
      "category": ["SINGLE PHASE", "THREE PH", "LT"],
      "make": "GOVT APPROVED"
    },
    {
      "product_name": "NET METER",
      "specification": null,
      "category": ["SINGLE PHASE", "THREE PH", "LT", "HT"],
      "make": "GOVT APPROVED"
    },
    {
      "product_name": "METER BOX",
      "specification": null,
      "category": ["SINGLE PHASE", "THREE PH", "MIP"],
      "make": "GOVT APPROVED"
    }
  ],

  "other_accessories": [
    {
      "product_name": "CONDUIT/SUDDLE/BEND",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "CABLE TIE",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "MC4 CONNECTOR",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "FLEXIBLE CONDUIT",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "ELECTRICAL TAPE",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "LUGS",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "SLEVES",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "FERRULES",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "DWC PIPE",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "CIVIL MATERIAL",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    },
    {
      "product_name": "CABLE TRAYS",
      "specification": "COMPANY STANDARD",
      "category": "AS PER REQUIREMENTS",
      "make": "REPUTED"
    }
  ]
};
